import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ConfirmNoteBarComponent } from './confirm-note-bar/confirm-note-bar.component';
import { ShellComponent } from './layout/shell/shell.component';
import { ToastComponent } from './toast/toast.component';
import { SearchSelectComponent } from './forms/search-select/search-select.component';

const COMMON_REEXPORTS = [CommonModule, FormsModule, ReactiveFormsModule, DragDropModule];

@NgModule({
  declarations: [ConfirmNoteBarComponent, ToastComponent, ShellComponent, SearchSelectComponent],
  // RouterModule here (not re-exported) is only for ShellComponent's own "Clients" nav
  // link — feature modules already get routerLink via their own RouterModule.forChild().
  imports: [...COMMON_REEXPORTS, RouterModule],
  exports: [...COMMON_REEXPORTS, ConfirmNoteBarComponent, ToastComponent, ShellComponent, SearchSelectComponent],
})
export class SharedModule {}
